var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12"},[_c('Card',{staticClass:"mt-12 p-2 flex justify-center"},[_c('button',{staticClass:"standard-btn",on:{"click":_vm.setLive}},[_vm._v("Set Live")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }